import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";

import { cancelSource, isCancelled, resolveCampaignUser } from "api/aiCampaigns";

import { ACCESS_DENIED_MESSAGE, canAccessCampaignStudio } from "./campaignUtils";
import { CampaignDetailsContainer } from "./campaignDetails/CampaignDetailsContainer";
import { Alert, Skeleton } from "./shared/StudioControls";
import { CampaignWorkspaceContainer } from "./workspace/CampaignWorkspaceContainer";
import "./campaignStudio.css";

const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch (_) {
    return null;
  }
};

// Route entry: resolves access once, then renders the workspace list or a
// campaign's detail flow. The backend allowlist remains authoritative.
export default function CampaignStudio({ match }) {
  const [access, setAccess] = useState({ status: "checking", token: null });
  const basePath = (match && match.path) || "/admin/campaign-studio";

  useEffect(() => {
    document.title = "Personalized Notifications | Flash Health";
    const source = cancelSource();
    Promise.resolve()
      .then(() => resolveCampaignUser(readStoredUser(), source.token))
      .then(user =>
        setAccess(canAccessCampaignStudio(user)
          ? { status: "allowed", token: user.token }
          : { status: "denied", token: null }))
      .catch(error => {
        if (!isCancelled(error)) setAccess({ status: "denied", token: null });
      });
    return () => source.cancel();
  }, []);

  return (
    <main className="cs-studio">
      {access.status === "checking" && <Skeleton heights={[72, 160, 220]} label="Checking notification access" />}
      {access.status === "denied" && (
        <div className="cs-page">
          <h1 className="cs-title">Personalized Notifications</h1>
          <Alert tone="danger" title="Access required">{ACCESS_DENIED_MESSAGE}</Alert>
        </div>
      )}
      {access.status === "allowed" && (
        <Switch>
          <Route
            path={`${basePath}/:campaignId(\\d+)`}
            render={({ match: detailMatch, history }) => (
              <CampaignDetailsContainer
                key={detailMatch.params.campaignId}
                token={access.token}
                campaignId={Number(detailMatch.params.campaignId)}
                history={history}
                basePath={basePath}
              />
            )}
          />
          <Route
            render={({ history }) => (
              <CampaignWorkspaceContainer token={access.token} history={history} basePath={basePath} />
            )}
          />
        </Switch>
      )}
    </main>
  );
}
